<header class="h-wrapper">
  <div class="h-container">
    <!-- Groupe gauche (desktop) -->
    <div class="h-first-group">
      <button class="btn-connect desktop-only" routerLink="/se-connecter">Se connecter</button>
    </div>
    <!-- Logo + Titre -->
    <div class="h-left-group">
      <a routerLink="/">
        <img src="assets/logo.png" alt="Logo Qaryos" class="h-logo-img" />
      </a>
    </div>

    <!-- Bloc navigation + bouton à droite -->
    <div class="h-navbar-group">
      <a
        routerLink="/"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="h-link desktop-only"
        >Accueil</a
      >

      <a routerLink="/offres" routerLinkActive="active" class="h-link desktop-only">Offres</a>
      <a routerLink="/a-propos" routerLinkActive="active" class="h-link desktop-only">À propos</a>
      <a routerLink="/contact" routerLinkActive="active" class="h-link desktop-only">
        <span class="icon-envelope">✉</span> Contactez-nous</a
      >

      <!-- Bouton mobile -->
      <div class="h-toggle mobile-only" [class.open]="menuOpen" (click)="menuOpen = !menuOpen">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>

  <!-- Navigation mobile -->
  <nav class="h-nav mobile-only" [class.open]="menuOpen">
    <a
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="h-link-mobile"
      (click)="menuOpen = false"
    >
      Accueil
    </a>
    <a
      routerLink="/offres"
      routerLinkActive="active"
      class="h-link-mobile"
      (click)="menuOpen = false"
      >Offres</a
    >
    <a
      routerLink="/a-propos"
      routerLinkActive="active"
      class="h-link-mobile"
      (click)="menuOpen = false"
      >À propos</a
    >
    <a
      routerLink="/contact"
      routerLinkActive="active"
      class="h-link-mobile"
      (click)="menuOpen = false"
    >
      <span class="icon-envelope">✉</span> Contactez-nous
    </a>

    <a
      routerLink="/se-connecter"
      class="h-link-mobile btn-connect-mobile"
      (click)="menuOpen = false"
    >
      Se connecter
    </a>
  </nav>
</header>

<main>
  <ng-container *ngIf="authChecked">
    <router-outlet></router-outlet>
  </ng-container>
</main>

<footer class="footer">
  <div class="footer-links">
    <a routerLink="/conditions-generales" class="nav-link">Conditions générales</a>
    <a routerLink="/conditions-utilisation" class="nav-link">Conditions générales d'utilisation</a>
    <a routerLink="/politique-confidentialite" class="nav-link">Politique de confidentialité</a>
    <a href="#" class="nav-link">Mentions légales</a>
    <a href="javascript:tarteaucitron.userInterface.openPanel();" class="nav-link">
      Gérer mes cookies
    </a>
    <!-- <a href="#" class="nav-link">Sécurité</a> -->
  </div>
</footer>
